/**
 * @desc 平台店铺应用表查询详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.AppAccountResponseDto>;
export function request(appName: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/appAccount/details/${appName}`, {
      method: "GET",

      ...options,
    }),
  );
}
